<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} una adscripción</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} las adscripciones</option>
        <option v-for="Adscripcion in Adscripciones" v-bind:key="Adscripcion.adscripcionId" :value="Adscripcion.adscripcionId" >{{Adscripcion.nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        Adscripciones: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      deshabilitado: false
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }

      //this.$store.dispatch(""A_SIFA_Catalogo_Establecer011Adscripcion", parametros);
    },
    methods: {
      cargaCatalogoAdscripciones() {
        
      console.log(this.parametros)
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba
        axios.post(api.conexion + api.SIFA.catalogos.C011Adscripciones, this.parametros).then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.Adscripciones = respuesta.data.Adscripciones;

              if (this.parametros.filtros != undefined && this.parametros.filtros != null) {
                this.Adscripciones = respuesta.data.Adscripciones.filter(cond => this.parametros.filtros.some(adscripciones => adscripciones == cond.adscripcionesId));
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        //console.log(evento)
        this.$store.dispatch("A_SIFA_Catalogo_Establecer011Adscripcion", parametros);
        this.$emit("valorParaElPadre", [evento, this.Adscripciones[evento.target.selectedIndex -1]]);

        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      }
    },
    created() {
      this.cargaCatalogoAdscripciones();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SIFA/Comun/Catalogos/C011Adscripciones.vue